import { render, staticRenderFns } from "./Material.vue?vue&type=template&id=5e790792&scoped=true"
import script from "./Material.vue?vue&type=script&lang=js"
export * from "./Material.vue?vue&type=script&lang=js"
import style0 from "./Material.vue?vue&type=style&index=0&id=5e790792&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e790792",
  null
  
)

export default component.exports